import React from "react";
import { Link } from "react-router-dom";
import "./dms.css";

const ComplianceBanner = ({ compliance }) => {
  if (!compliance || compliance.isAdmin) return null;

  if (compliance.isLocked) {
    const missing = (compliance.missingRequiredCategories || [])
      .map((c) => c.categoryName)
      .filter(Boolean)
      .join(", ");
    return (
      <div className="dms-banner is-locked">
        <strong>Zorunlu dökümanlar eksik.</strong>{" "}
        Panel kilitli; yalnızca Belgelerim kullanılabilir.
        {missing ? ` Eksik: ${missing}.` : ""}{" "}
        <Link to="/my-documents">Belgelerim’e git</Link>
      </div>
    );
  }

  if (compliance.lockEnabled && !compliance.isCompliant) {
    return (
      <div className="dms-banner is-info">
        {compliance.statusMessage ||
          "Kilit kapalı: takip çalışır, panel kilitlenmez. Eksik zorunlu dökümanlarınız var."}{" "}
        <Link to="/my-documents">Belgelerim</Link>
      </div>
    );
  }

  return null;
};

export default ComplianceBanner;
